import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import PolygonIcon from '../../../icons/PolygonIcon';
import { useDispatch, useSelector } from 'react-redux';
import { createTheme } from '@mui/material/styles';
import { setActiveDrawTool, setFilterGeometry, setIsLocationFilterOnly } from '../../../redux/slices/filterSlice';
import { emitCustomEvent } from 'react-custom-events';
import Events from '../../../defaults/Events';
import ValueConstants from '../../../defaults/ValueConstants';
import { Box, Typography, Grid } from '@mui/material';
import HelpIcon from "@mui/icons-material/Help";

const theme = createTheme({
    overrides: {
      
    },
  });
  
const iconButtonStyles = {
    buttonStyle: {
        borderRadius: "50%",
        width: "36px",
        height: "36px",
        padding: "6px"
    },
    activeStyle: {
        backgroundColor: "#6f7482"
    },
    activeIconStyle: {
        color: theme.palette.canvasColor
    }
}

export default function LocationFilter({isCreatingActualActivity, isCreatingActualTreatment, 
  isCreatingPlannedTreatment, isCreatingPlannedActivity}) {
    const dispatch = useDispatch();
    //const filterGeometry = useSelector((state) => state.filter.filterGeometry);
    const activeDrawTool = useSelector((state) => state.filter.activeDrawTool);
    const currentMapScale = useSelector((state) => state.map.currentMapScale);

    // const removeGeometryToolSelected = () => 
    // {
    //     dispatch(setFilterGeometry(null));
    // }

    const cancelSelectedTool = () => {
        dispatch(setActiveDrawTool(null));
        dispatch(setFilterGeometry(null));
        emitCustomEvent(Events.DisableDrawMode);
        dispatch(setIsLocationFilterOnly(false))
    }

    const drawFilterCompleted = (geometry) => {
        dispatch(setFilterGeometry(geometry));
        dispatch(setActiveDrawTool(null));
    }

    const polygonToolSelected = () => 
    {
      dispatch(setIsLocationFilterOnly(true))
      if(!isCreatingActualActivity && !isCreatingActualTreatment && !isCreatingPlannedTreatment && !isCreatingPlannedActivity){
        if (activeDrawTool === "polygon") 
        {
            cancelSelectedTool();
        }
        else 
        {
            dispatch(setActiveDrawTool("polygon"));
            emitCustomEvent(Events.EnableDrawMode, { geometry: null, callback: drawFilterCompleted });
        }
      }
    }
    
    const polygonSelectedStyle = (activeDrawTool === "polygon") ? iconButtonStyles.activeStyle : null;
    const polygonIconSelectedStyle = (activeDrawTool === "polygon") ? iconButtonStyles.activeIconStyle : null;
    const mapScaleNotAcceptable = !currentMapScale || currentMapScale > ValueConstants.BoundingBoxAcceptableScaleValue;

    return (
        <div className="filter-item-geometry">
            <label>Select On Map:</label>
            <div className="filter-item-location-tools">
                <IconButton
                    style={{ ...iconButtonStyles.buttonStyle, ...polygonSelectedStyle }}
                    tooltip="Polygon Tool"
                    onClick={polygonToolSelected}
                    disabled={mapScaleNotAcceptable}>
                    <PolygonIcon style={{ width: "18px", color: theme.palette.borderColor, ...polygonIconSelectedStyle }} />
                </IconButton>
                {mapScaleNotAcceptable ?
                <Grid
                  item
                  size={12}
                  
                  container
                  direction="row"
                  className="grid-item"
                  style={{ alignItems: "center" }}
                >
                  <Grid item size={512}>
                    <Box sx={{ backgroundColor: "#D3D3D3", marginTop: "10px"}}
                        style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap'}}>
                      <HelpIcon fontSize="small" color="primary" style={{ paddingRight: "5px" }}/>
                      <Typography fontSize={12}>
                        You must zoom in to use this function
                      </Typography>
                    </Box>
                  </Grid>
                </Grid> : null}
            </div>
        </div>
    )
  }